import { mutations } from '@/store/modules/resources/mutations';
import { getters } from '@/store/modules/resources/getters';
import { emptyResourceSummary } from '@/store/defaults';
import { actions } from '@/store/modules/resources/actions';
import { SortOrder } from '@/services/common/enums';
const defaultSearchRequest = {
    SearchCriteria: {
        text: undefined,
        categories: [],
        keywords: [],
        ResourceType: undefined,
    },
    Limit: process.env.VUE_APP_PAGE_SIZE,
    Offset: 0,
    Sort: SortOrder.TitleAZ,
};
const state = {
    isSearching: false,
    currentResponse: {
        items: [],
        total: 0,
        limit: 0,
        offset: 0,
        categories: [],
        resourceTypeSummary: emptyResourceSummary,
    },
    defaultSearchRequest: {
        ...JSON.parse(JSON.stringify(defaultSearchRequest)),
    },
    currentSearchRequest: {
        ...JSON.parse(JSON.stringify(defaultSearchRequest)),
    },
};
export const Resources = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
